module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman-mobile_f4de35.png";